<script setup lang="ts">
import Badge from './Badge.vue';

type BadgeSize = 'sm' | 'md' | 'lg';

withDefaults(
  defineProps<{
    size?: BadgeSize;
    position?: 'overlay' | 'inline';
  }>(),
  {
    size: 'sm',
    position: 'overlay'
  }
);

// Using the actual plus-w-100.png asset from public folder
</script>

<template>
  <Badge
    :size="size"
    :position="position"
    variant="bg-green text-white"
    class="whitespace-nowrap"
  >
    <!-- Plus image (matches liquid card-product-badge-plus-pattern.liquid) -->
    <img
      src="/plus-w-100.png"
      class="my-1 h-auto w-10"
      alt="Plus"
      width="40"
      height="12"
      loading="lazy"
    />
  </Badge>
</template>
